import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchPaymentFrequencyEnumData } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class PaymentFrequencyTypeahead extends Component {
    static propTypes = {
        fetchPaymentFrequencyEnumData: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        isClearable: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.object
        ]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        isClearable: true,
        renderMultiSuggestion
    };

    componentDidMount() {
        this.init();
    }

    init = async () => {
        const response = await this.props.fetchPaymentFrequencyEnumData(PaymentFrequencyTypeahead.name, 'PaymentFrequencyKind');
        const arr = await response.value.list;
        const value = arr.find(payment => payment.id === this.props.value.id);
        this.props.onChangeSuggestion({ label: value.alternativeName, id: value.id }, true);
    }

    onFocus = async () => {
        await this.props.fetchPaymentFrequencyEnumData(PaymentFrequencyTypeahead.name, 'PaymentFrequencyKind');
    };

    render() {
        const options = this.props.suggestions.map(paymentFrequency =>
            ({ label: paymentFrequency.alternativeName, id: paymentFrequency.id })
        );
        return (
            <MultiTypeahead
                options={options}
                isLoading={this.props.loading}
                value={this.props.value}
                titleId="paymentFrequencyMonth"
                animatedPlaceholder
                isRequired
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                error={this.props.error}
                isClearable={this.props.isClearable}
                disabled={this.props.disabled}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === PaymentFrequencyTypeahead.name
            ? typeahead.list
            : PaymentFrequencyTypeahead.defaultProps.suggestions,
    loading: typeahead.loading
});

export default connect(mapStateToProps, {
    fetchPaymentFrequencyEnumData,
    clearTypeahed
})(PaymentFrequencyTypeahead);
